import { Shop } from "../../shop/models/Shop";

export interface PromotionDetailForm {
  name: string;
  shop?: Shop;
  startDate?: string | Date;
  endDate?: string | Date;
  promotionGroup: PromotionGroupForm;
}

export interface PromotionGroupForm {
  channelsSelected: number[];
  conditionType: string;
  conditionItemGroups: PromotionItemGroupForm[];
  promotionItemGroups: PromotionItemGroupForm[];
  promotionConditionPrices: PromotionConditionPriceForm[];
  orderLimit: number;
  promotionHold: boolean;
}

export interface PromotionItemGroupForm {
  items: PromotionItemForm[];
}

export enum PromotionItemStatus {
  Init,
  Loading,
  Success,
  Fail
}

export interface PromotionItemForm {
  name: string;
  sku: string;
  quantity: number;
  status: PromotionItemStatus;
}

export interface PromotionConditionPriceForm {
  price: number;
  promotionItemGroups: PromotionItemGroupForm[];
}
